import React from 'react'
import { Route, IndexRoute } from 'react-router'

import HomePage from 'home/HomePage';
import Layout from 'Layout';
import { initStore, getUserCreditNoteInformations } from 'thunks';
import StatisticsPage from "../pages/Admin/StatisticsPage";
import StatisticsIFramePage from "../pages/Admin/StatisticIFramePage";
import { setRedirectUrl } from "../actions/actions/payment";
import ImportCodaTesting from '../components/Admin/OrganizationConfiguration/ImportCodaTesting';
import { setApplication } from 'actions';
import NotFoundFrame from "../pages/NotFoundFrame";
import EventStatisticsPage from "../pages/Admin/EventStatisticsPage";
import ContributionStatisticsPage from '../pages/Admin/ContributionStatisticsPage';
import CommunityRedirect from "../components/CommunityRedirect";
import { TTP_HOME_URL, TTP_PAYMENT_URL } from 'Config';
import PaperStatisticsPage from '../pages/Admin/PaperStatisticsPage';
import WebinarStatisticsPage from '../pages/Admin/WebinarStatisticsPage';


export const urls = {
  index: '/',
  autoLogin: 'autologin',
  notFound: '*',
  payment: 'payment',
  paymentMethode: 'paymentMethode',
  adyenCallback: 'adyenCallback',
  ogoneCallback: 'ogoneCallback',
  bankTransfer: 'bankTransfer',
  adminPage: 'adminPage',
  ordersAdmin: 'ordersAdmin',
  bankTransfersAdmin: 'bankTransfersAdmin',
  importCoda: 'importCoda',
  users: 'users',
  codaresult: 'codaresult',
  paypalCallback: 'paypalCallback',
  mapcoda: 'mapcoda',
  importCodaTesting: 'importCodaTesting',
  issuerPaymentAdmin: 'issuerPaymentAdmin',
  callback: 'callback',
  userCreditNote: 'userCreditNote',
  paymentMode: 'paymentMode',
  refundPage: 'refund',
  organizationConf: 'organizationConf',
  communityRedirect: '(:lng/)community(/:communityUrl)(/:communityId)',
  admin: {
    assignments: 'admin/assignments',
    bankTransferInformations: 'admin/reconciliation/bankTransferInformations',
    statistics: 'admin/statistics',
    feesStatistics: 'admin/feesStatistics',
    rappels: 'admin/rappels',
    statisticsIFrame: 'admin/statisticsIFrame',
    actionRelance: 'admin/relance',
    eventStatistics: 'admin/eventstats',
    contributionStatistics: 'admin/contributionstats',
    paperStatistics: 'admin/paperstats',
    webinarStatistics: 'admin/webinarStats',
  },
};

export const getRoutes = (store) => {

  const requireLogin = (nextState, replace, next) => {
    store.dispatch(initStore());
    let fetched = store.getState().auth.fetched;
    if (!fetched) {
      let path = (window.location.pathname + window.location.search).substr(1);
      store.dispatch(setRedirectUrl('/admin/eventstats'));
      replace('/');
    }
    next();
  };

  const initCustomStore = (nextState, replace, next) => {
    store.dispatch(initStore());
    next();
  };

  const isAdmin = (nextState, replace, next) => {
    store.dispatch(initStore());
    let { auth } = store.getState();

    if (!auth.fetched) {
      let path = (window.location.pathname + window.location.search).substr(1);
      if (!auth.token) {
        const gotoUrl = TTP_HOME_URL + '?goto=' + TTP_PAYMENT_URL + path
        window.location.replace(gotoUrl)
        return;
      } else {
        // store.dispatch(setRedirectUrl(path));
        next();
      }
    } else if ((auth.fetched && auth.user.type == "ADMIN") || (auth.fetched && auth.loggedAs == "ADMIN")) {
      store.dispatch(setRedirectUrl('/admin/eventstats'));
      next();
    } else {
      replace('/');
      next();
    }
  };

  const isBillingAdmin = (nextState, replace, next) => {
    let { fetched, loggedAs } = store.getState().auth;
    if (!fetched || "ADMIN" != loggedAs) {
      replace('/');
    }
    next();
  }

  const requireUser = (nextState, replace, next) => {
    store.dispatch(initStore());
    let { auth } = store.getState();
    var url = window.location.search;
    const { params, location } = nextState;
    let query = new URLSearchParams(location.search);
    if (auth.fetched) {
      next();
    }


    replace('/');
    next();

  };

  const switchApplication = (nextState, replace, next) => {
    const { location: { pathname } } = nextState;
    let application = "PAYMENT";
    const { params } = store.getState();
    if (Object.values(urls).indexOf(pathname) != -1 && params.application) {
      next();
      return;
    }
    // const appsUrls = {
    //   'EMAILING': emailing_urls,
    //   'SMS': sms_urls,
    //   'EBOX': ebox_urls,
    //   'NOTIFICATION': notification_urls
    // };
    //
    // for (let app in appsUrls) {
    //   if (Object.values(appsUrls[app]).some(url => (new RegExp("/" + url.replace(/\(\/:.+\)/g, '') + "(|/[0-9]*(/)?)$")).test(pathname))) {
    //     application = app;
    //     break;
    //   }
    // }
    store.dispatch(setApplication(application));
    next();
  };

  return (
    <Route path={urls.index} component={Layout} onEnter={switchApplication}>
      <IndexRoute component={HomePage} />
      {/*<Route path={urls.paymentMethode} component={PaymentModes} onEnter={requireLogin}/>*/}
      {/* <Route path={urls.adyenCallback} component={AdyenCallback} onEnter={requireLogin}/> */}
      {/* <Route path={urls.ogoneCallback} component={OgoneCallback} onEnter={requireLogin}/> */}
      {/* <Route path={urls.bankTransfer} component={BankTransfer} onEnter={requireLogin}/> */}
      {/* <Route path={urls.payment} component={Payment} onEnter={requireLogin}/> */}
      {/* <Route path={urls.userCreditNote} component={userCreditNote} onEnter={requireLogin}/> */}
      {/* <Route path={urls.adminPage} component={AdminPage} onEnter={isAdmin}/> */}
      {/* <Route path={urls.ordersAdmin} component={OrdersAdmin} onEnter={isAdmin}/> */}
      {/* <Route path={urls.bankTransfersAdmin} component={BankTransfersAdmin} onEnter={isAdmin}/> */}
      {/* <Route path={urls.importCoda} component={ImportCoda} onEnter={isAdmin}/> */}
      {/* <Route path={urls.users} component={Users} onEnter={isAdmin}/> */}
      {/* <Route path={urls.codaresult} component={ImportCodaResult} onEnter={isAdmin}/> */}
      {/* <Route path={urls.mapcoda} component={MappingCoda} onEnter={isAdmin}/> */}
      <Route path={urls.admin.webinarStatistics} component={WebinarStatisticsPage} onEnter={isAdmin} />
      <Route path={urls.admin.statistics} component={StatisticsPage} onEnter={isAdmin} />
      <Route path={urls.admin.contributionStatistics} component={ContributionStatisticsPage} onEnter={isAdmin} />
      <Route path={urls.admin.paperStatistics} component={PaperStatisticsPage} onEnter={isAdmin} />
      {/* <Route path={urls.admin.feesStatistics} component={FeesStatisticsPage} onEnter={isAdmin}/> */}
      <Route path={urls.admin.statisticsIFrame} component={StatisticsIFramePage} onEnter={isAdmin} />
      {/* <Route path={urls.callback} component={Callback} onEnter={requireLogin}/> */}
      <Route path={urls.importCodaTesting} component={ImportCodaTesting} onEnter={isAdmin} />
      <Route path={urls.admin.eventStatistics} component={EventStatisticsPage} onEnter={isAdmin} />
      {/* <Route path={urls.refundPage} component={RefundPage} onEnter={requireLogin}/> */}
      <Route path={urls.communityRedirect} component={CommunityRedirect} onEnter={requireLogin} />
      {/* <Route path={urls.paymentMethode} component={PaymentPage} onEnter={requireLogin}/> */}

      {/* <Route path={urls.paymentMethode} component={PaymentPage} onEnter={requireLogin}/> */}
      {/* <Route path={urls.admin.codaFile} component={CodaFilePage} onEnter={requireLogin}/> */}
      <Route path={urls.notFound} component={NotFoundFrame} onEnter={initCustomStore} />

      {/* <Route path={urls.notFound} component={PaymentError} onEnter={initCustomStore}/> */}
    </Route>
  );
}



// WEBPACK FOOTER //
// ./app/router/index.js